import { MessageBeforeManuallyAddPartActionsEnum } from "./../../enums/message-before-manually-add-part-actions.enum";
import { ServiceRequestDetailsClientDTO } from "@shared/models/service-request-details-client-dto";
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { UntypedFormControl, Validators } from "@angular/forms";
import { debounceTime, first, startWith, switchMap, tap } from "rxjs/operators";
import { PartService } from "@core/services/part.service";
import { PartDTO } from "../../models/part-dto";
import { BudgetPartItemFormModalComponent } from "../budget-part-item-form-modal/budget-part-item-form-modal.component";
import { MessageBeforeManuallyAddPartModalComponent } from "../message-before-manually-add-part-modal/message-before-manually-add-part-modal.component";
import { BudgetPartItemsDTO } from "../../models/budget-part-items-dto";
import { MatOptionSelectionChange } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { BudgetDetails } from "@shared/models/service-request-details-dto";
import { DEFAULT_PAGINATION } from "@shared/constants/default-pagination";
import { PageManager } from "@shared/models/page-manager";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { KeycloakHelperService } from "@core/services/keycloak.helper.service";
import { PartSearchFilterDto } from "@shared/models/part-search-filter-dto";
import { MessageBeforeManuallyAddPartWarningUserModalComponent } from "../message-before-manually-add-part-warning-user-modal/message-before-manually-add-part-warning-user-modal.component";
import { ServiceRequestDetailsVehicleDTO } from "@shared/models/service-request-details-vehicle-dto";

@Component({
  selector: "app-smartfleet-part-manufacture-partName-partCode-auto-complete",
  templateUrl: "./part-manufacture-partcode-auto-complete.html",
  styleUrls: ["./part-manufacture-partcode-auto-complete.scss"],
  standalone: false
})
export class PartManufacturePartcodeAutoComplete
  extends GenericComponent
  implements OnInit
{
  loading = false;
  part = new UntypedFormControl();
  searchForm = this.fb.group({
    part: this.part
  });

  parts: PartDTO[] = [];

  pageManager: PageManager = {
    totalElements: 0,
    pageIndex: DEFAULT_PAGINATION.PAGE_INDEX,
    pageSize: DEFAULT_PAGINATION.PAGE_SIZE
  };

  partSelected = false;
  @Input() isFee?: boolean;
  @Input() title = "";
  @Input() requiredText = "";
  @Input() manufacturerId: number;
  @Input() context: string;
  @Input() client: ServiceRequestDetailsClientDTO;
  @Input() vehicle: ServiceRequestDetailsVehicleDTO;
  @Input() budget: BudgetDetails;
  @Input() fee: boolean;
  @Output() onChange: any = new EventEmitter<PartDTO | BudgetPartItemsDTO>();
  @Output() focusOnPartManufacturerField = new EventEmitter<boolean>();
  @Input() set required(value: boolean) {
    if (value && !this._disabled) {
      this.searchForm.controls.part.setValidators([Validators.required]);
    }
  }
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  private _disabled = false;

  constructor(
    injector: Injector,
    private partService: PartService,
    private keycloakHelperService: KeycloakHelperService,
    private loadingDrivebService: LoadingDrivebService,
    private dialog: MatDialog
  ) {
    super(injector);
  }

  ngOnInit() {
    this.part.valueChanges
      .pipe(
        startWith(""),
        debounceTime(700),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const searchForm = {} as PartSearchFilterDto;
            searchForm.value = value;
            return this.partService.findByManufactureOrPartNameOrPartCodeAPI(
              searchForm,
              this.pageManager,
              "",
              this.client.id.toString(),
              this.vehicle?.id.toString(),
              this.fee
            );
          } else {
            this.loading = false;
            this.loadingDrivebService.setAutoMode(true);
            this.onChange.emit({} as PartDTO);
            return new Observable<PartDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.parts = data;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        this.partSelected = false;
      });
  }

  openCustomPartModal() {
    this.dialog
      .open(MessageBeforeManuallyAddPartWarningUserModalComponent, {
        width: "900px",
        data: { client: this.client, budget: this.budget, isFee: this.isFee }
      })
      .afterClosed()
      .subscribe((action) => {
        if (action == MessageBeforeManuallyAddPartActionsEnum.CREATE_PART) {
          this.addBudgetPartItem();
        }
        this.focusOnPartManufacturerField.emit(action);
      });
  }

  handlePartChange(event: MatOptionSelectionChange, part: PartDTO) {
    if (event.isUserInput) {
      this.onChange.emit(part);
    }
    this.partSelected = true;
  }

  isCarWorkshopLogged() {
    return this.keycloakHelperService.isCarWorkshopLogged();
  }

  addBudgetPartItemForCarWorkshop() {
    this.dialog
      .open(MessageBeforeManuallyAddPartModalComponent, {
        width: "900px",
        data: { client: this.client, budget: this.budget, isFee: this.isFee }
      })
      .afterClosed()
      .subscribe((action) => {
        if (action == MessageBeforeManuallyAddPartActionsEnum.CREATE_PART) {
          this.addBudgetPartItem();
        }
        this.focusOnPartManufacturerField.emit(action);
      });
  }

  addBudgetPartItem() {
    this.dialog
      .open(BudgetPartItemFormModalComponent, {
        width: "900px",
        data: { client: this.client, budget: this.budget }
      })
      .afterClosed()
      .subscribe((data) => {
        if (data) {
          this.searchForm.patchValue({
            part: data.partName
          });
          this.onChange.emit(data);
        }
      });
  }

  clean() {
    this.searchForm.reset();
  }
}
